import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../../store';

import { CommentsButton, ICommentsButtonDispatch, ICommentsButtonProps } from './index';

import { changeEdditing, closeComments, openComments } from '../../../store/comments';

function mapStateToProps(state: IState): ICommentsButtonProps {
  return {
    commentText: state.commentsData.commentText,
    isOpen: state.commentsData.isOpen,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): ICommentsButtonDispatch {
  return {
    changeEdditing: (editing: boolean) => {
      dispatch(changeEdditing(editing));
    },
    closeComments: () => {
      dispatch(closeComments());
    },
    openComments: () => {
      dispatch(openComments());
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CommentsButtonContainer = connect<ICommentsButtonProps, ICommentsButtonDispatch, any>(
  mapStateToProps,
  mapDispatchToProps,
)(CommentsButton);
